import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function WifiIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M19.0563 10.9289C15.1511 7.02369 8.81946 7.02369 4.91421 10.9289L3.5 9.51472C8.18629 4.82843 15.7843 4.82843 20.4706 9.51472L19.0563 10.9289Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M6.32843 12.3431C9.45262 9.21895 14.5179 9.21895 17.6421 12.3431L16.2279 13.7574C13.8848 11.4142 10.0858 11.4142 7.74264 13.7574L6.32843 12.3431Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M14.8137 15.1716C13.2516 13.6095 10.719 13.6095 9.15685 15.1716L11.9853 18L14.8137 15.1716Z",
    fill: "currentColor"
  }));
}